// Three-icon row used in the photo's "date / time / location" band. Stroke-only
// gold SVG glyph with a caps-serif two-line label below.
const ICON_BASE =
  'h-[34px] w-[34px] text-gold-deep';

const ICONS = {
  calendar: (
    <svg
      viewBox="0 0 32 32"
      className={ICON_BASE}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="4" y="7" width="24" height="20" rx="2" />
      <path d="M10 4v6M22 4v6" />
      <path d="M4 14h24" />
      <path
        d="M16 19c-1.5 0-2.6 1-2.6 2.3 0 1 .6 1.7 1.6 2.4l1 .7c1 .7 1.6 1.4 1.6 2.4 0 1.3-1.1 2.3-2.6 2.3s-2.6-1-2.6-2.3M16 17.4v9.2"
        fill="#B89A6B"
        stroke="none"
      />
    </svg>
  ),
  clock: (
    <svg
      viewBox="0 0 32 32"
      className={ICON_BASE}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="13" />
      <path d="M16 8v8l5 3" />
    </svg>
  ),
  pin: (
    <svg
      viewBox="0 0 32 32"
      className={ICON_BASE}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M16 28s-9-8.5-9-15.5C7 7.4 11 4 16 4s9 3.4 9 8.5C25 19.5 16 28 16 28z" />
      <circle cx="16" cy="13" r="3.5" />
    </svg>
  ),
  // Stroke-only church silhouette: spire/cross on top, peaked roof, narrow
  // body with an arched door. Same ICON_BASE class + stroke geometry as
  // calendar/clock/pin so the four glyphs read at the same visual weight.
  church: (
    <svg
      viewBox="0 0 32 32"
      className={ICON_BASE}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* Cross / spire */}
      <path d="M16 2v4" />
      <path d="M14 4h4" />
      {/* Body */}
      <path d="M7 27V14l9-6 9 6v13" />
      {/* Peaked roof (drawn separately so the cross sits above the ridge) */}
      <path d="M7 14h18" />
      {/* Arched door */}
      <path d="M13.5 27v-4a2.5 2.5 0 0 1 5 0v4" />
    </svg>
  ),
};

const BASE_LABEL_CLASS =
  'text-center font-caps text-[11px] uppercase leading-snug tracking-[0.2em] text-ink';
const LINK_LABEL_CLASS =
  'underline decoration-gold/60 underline-offset-4 hover:text-gold focus-visible:text-gold focus-visible:outline-none';

export default function IconLine({ icon = 'calendar', label, href }) {
  const glyph = ICONS[icon] ?? ICONS.calendar;
  const hasLink = typeof href === 'string' && href.length > 0;
  const labelClass = hasLink ? `${BASE_LABEL_CLASS} ${LINK_LABEL_CLASS}` : BASE_LABEL_CLASS;

  const labelEl = hasLink ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir ubicación en Google Maps"
      className={labelClass}
    >
      {label}
    </a>
  ) : (
    <p className={labelClass}>{label}</p>
  );

  return (
    <div className="flex flex-col items-center gap-2">
      {glyph}
      {labelEl}
    </div>
  );
}
